var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.7,
    height: 21.7,
    viewBox: "0 0 15.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smartphone",
    transform: "translate(-4.15 -1.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2693",
    "data-name": "Group 2693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-376-4202.15a2.853,2.853,0,0,1-2.85-2.849v-16a2.854,2.854,0,0,1,2.85-2.851h10a2.854,2.854,0,0,1,2.85,2.851v16a2.853,2.853,0,0,1-2.85,2.849Zm-1.15-18.85v16a1.15,1.15,0,0,0,1.15,1.149h10a1.151,1.151,0,0,0,1.15-1.149v-16a1.152,1.152,0,0,0-1.15-1.15h-10A1.151,1.151,0,0,0-377.15-4221Zm4.15,15.5a.85.85,0,0,1-.85-.85.85.85,0,0,1,.85-.85h4a.85.85,0,0,1,.85.85.85.85,0,0,1-.85.85Z",
    transform: "translate(383 4225)",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.1b9f0d58054c3c571b9cfc9494fa5a2f.svg";
export { ForwardRef as ReactComponent };